import { Component, EventEmitter, Input, Output } from '@angular/core'; 
import { ClassEnrolment } from '../../../models/class-enrolment.model';

@Component({
    selector: 'app-enrolment-subscription',
    templateUrl: './enrolment-subscription.component.html',
    styleUrls: ['./enrolment-subscription.component.scss'],
    standalone: false
})
export class EnrolmentSubscriptionComponent {
  @Input() viewMode: boolean = true;
  @Input() showNA: boolean = true;
  optInForEmail: boolean = false;
  optInForText: boolean = false; 
  @Input() set Enrolment(v: ClassEnrolment) { 
  }
  @Output() subscriptionUpdated = new EventEmitter<ClassEnrolment>();
}
